<template>
    <div>
        <span v-if="loading">
            <i class="fa fa-spinner fa-spin"></i> {{ loadingtxt }}
        </span>
        <span v-else v-html="txt"></span>
    </div>
</template>

<script>
    // import Vue from 'vue'
    // let txt = Vue.$trans(`没有找到亲要的数据哦~`);
    // const commonCookie = require('../../services/common/cookie');
    // import commonCookie from '../../services/common/cookie';
    // let lang = commonCookie.getCookie('ksc_lang') || 'zh';
    // let txt = '没有数据';
    // let loadingtxt="数据加载中...";
    // try {
    //     txt = window['ksc_i18n_dict'].no_data_you_want;
    //     loadingtxt = window['ksc_i18n_dict'].data_loading;
    // } catch(e) {

    // }
    // Vue.use(i18n.VueTransPlugin, );

    import {$trans} from 'ksc-i18n';
    let txt = $trans(`没有数据`);
    let loadingtxt = $trans(`数据加载中...`);
    
    export default {
        name: "TableNoData",
        props: {
            loading: {
                type: Boolean,
                default: true
            },
            txt: {
                type: String,
                default: txt//window['ksc_i18n_dict'] ? .no_data_you_want
            },
            loadingtxt:{
                type: String,
                default: loadingtxt//window['ksc_i18n_dict'] ? .data_loading
            }
        }
    }
</script>

<style scoped>

</style>
